<ion-button type="button" fill="clear" class="buttonPill">
  <div class="imageCont">
    @if (imageSrc) {
      <img src="{{ imageSrc }}" />
    } @else {
      <span class="{{ iconName }}"></span>
    }

  </div>

  <span class="separator"></span>

  <div class="buttonTextCont">
    <p class="buttonText">{{ buttonText }}</p>
  </div>

  <div class="fillDiv"></div>
</ion-button>
